<template>
  <div class="text-center pa-2">
    <v-img
      :max-width="small ? 150 : ($vuetify.breakpoint.smAndDown ? 200 : 300)"
      :width="small ? 150 : ($vuetify.breakpoint.smAndDown ? 200 : 'auto')"
      :src="companyImage"
      class="mx-auto"
    />
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: 'CompanyHeader',
    props: {
      small: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState({
        company: state => state.app.company,
    

        companyImage: state => state.companyFull?.logo,

      }),

    },
  }
</script>

<style scoped>

</style>
